module.exports = __webpack_public_path__ + "img/d200904-1.591530af.jpg";